import fileDownload from "js-file-download";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import { useParams } from "react-router-dom";
import { SIZE_DOC_UPLOAD } from "../../../../../services/config";
import { findOne, getfile, save } from "../../../../../services/File__Servive";
import notifyContext from "../../../../Context/notifyContext";
import Loader from "../../../../Loader/Loader";
import PdfRender from "../../../../PdfRender/PdfRender";

const FormFile = ({ fileId = 0, view = false, modify = false, setShowAdd }) => {
  const notify = useContext(notifyContext);
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState({
    id: 0,
    name: "",
  });

  const paramsRoute = useParams();
  const [id, setId] = useState(fileId);

  useEffect(() => {
    if (id !== undefined && id > 0) {
      setIsLoading(true);
      fetchOneFile(id);
    }
  }, [id]);

  const fetchOneFile = async (fileId) => {
    findOne(fileId)
      .then((response) => {
        setFile(response.data);
        fecthFileDoc(response.data.filename);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const fecthFileDoc = async (filename) => {
    getfile(filename)
      .then((response) => {
        setSelectedFile(response.data);

        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (file.name === "") {
      display_errors.push({
        message: "Veuillez saisir le nom du fichier",
        id_input: "name",
      });
    }

    if (!isFilePicked && !modify) {
      display_errors.push({
        message: "Selectionnez un fichier",
        id_input: "file",
      });
    }

    if (isFilePicked) {
      if (
        [".pdf", "application/pdf"].findIndex((elt) => {
          return elt === selectedFile.type;
        }) === -1
      ) {
        display_errors.push({
          message: "Type de fichier incorrect. (Fichier pdf autorisé)",
          id_input: "file",
        });
      } else if (selectedFile.size > SIZE_DOC_UPLOAD) {
        display_errors.push({
          message:
            "Taille de fichier très grand (taille ne doit pas dépasser 1Mo)",
          id_input: "file",
        });
      }
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      save(
        isFilePicked
          ? { ...file, folderId: paramsRoute.id, file: selectedFile }
          : { ...file, folderId: paramsRoute.id }
      )
        .then(() => {
          setIsSend(false);
          notify("Enregistré avec succès", "success");
          setShowAdd(false);
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setFile((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  /* FILE HANDLE */
  const [selectedFile, setSelectedFile] = useState(); // contient des informations sur le fichier actuellement sélectionné.
  const [isFilePicked, setIsFilePicked] = useState(false); //détermine si un fichier a été sélectionné ou non.

  const handleChangeFile = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    }
  };

  /* FILE HANDLE END */
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);

  return (
    <Fragment>
      <form className="form file" onSubmit={handleSubmit}>
        {!view && (
          <div className="form-header">
            <small>
              Les champs comportant <span className="required">*</span> sont
              obligatoires
            </small>
            <div className="error">{error}</div>
          </div>
        )}

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="description_resquest" className="form-label">
              Nom :
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="form-input"
              value={file.name}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="simulation" className="form-label">
            Document :
          </label>
          {!view && (
            <input
              type="file"
              name="file"
              id="file"
              className="form-file"
              onChange={handleChangeFile}
              accept=".pdf, application/pdf,"
            />
          )}
        </div>

        {!view && (
          <div className="form-footer">
            <button type="submit" className="btn">
              <MdSave />
              Enregistrer
            </button>
            {/* <button type="reset" className="btn btn--outline">
              <MdCancel />
              Annuler
            </button> */}
          </div>
        )}
      </form>
      {selectedFile && (
        <div
          className="preview-pdf"
          style={{
            width: "100%",
            height: "100%",
            overflow: "auto",
          }}
        >
          {(view || modify) && (
            <button
              className="btn"
              onClick={() => fileDownload(selectedFile, file.nameDownload)}
            >
              Télécharger
            </button>
          )}

          <PdfRender file={selectedFile} />
        </div>
      )}

      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default FormFile;
